import { MigrationReport } from '@/types/migration';
import { TableSection } from '@/types/table';

export const emptyReport = (): MigrationReport => ({ changes: [], issues: [] });

export const reportChanges = (report: MigrationReport, item: string, before: string, after: string, count: number) => {
  if (count > 0) {
    report.changes.push({ location: 'Application', item, before, after: `${after} (${count})` });
  }
};

export const toTableSections = (report: MigrationReport): TableSection[] => {
  const sections: TableSection[] = [];

  if (report.changes.length) {
    sections.push({
      title: 'Changes made',
      columns: ['Location', 'Item', 'Before', 'After'],
      rows: report.changes.map((change) => [change.location, change.item, change.before, change.after])
    });
  }

  if (report.issues.length) {
    sections.push({
      title: 'Issues left to resolve',
      columns: ['Location', 'Item', 'Found', 'Issue'],
      rows: report.issues.map((issue) => [issue.location, issue.item, issue.found, issue.issue])
    });
  }

  return sections;
};
